import App from "../../app/App";

const Layout = {

    init() {

        this.el = $('[component="Layout"]');
        this.navigation = this.el.find('[element="navigation"]');
        this.button = {
            logout: this.el.find('[element="logout"]'),
            nav_toggle: this.el.find('[element="navSwitcher"]'),
            buttonToggleClass: this.el.find('.toggleClass'),
            links: this.el.find('a')
        }

        this.skeletons = this.el.find('[element="skeleton"]');

        this.start();
        this.bind();
    },

    bind() {
        this.navigation.find("a").click((event) => {
            this.navigation.find("li.active").removeClass("active");

            setTimeout(() => {
                window.location = $(event.currentTarget).attr("href");
            },300);
            return false;
        });

        this.button.logout.click(() => {
            Layout.logout();
            App.showLoading();

            return false;
        });

        this.button.nav_toggle.click(() => {
            $(Layout.el).toggleClass("hiddenMenu");

            App.ajax("toggle_menu", null);
        });

        this.el.find("a.disabled").click((element) => {
            if ( $(element.currentTarget).is(".disabled") ) {
                return false;
            }
        });

        this.button.buttonToggleClass.on("click", function(e) {
            e.preventDefault();

            let data = $(this).data();

            if ( !data.target ) {
                console.warn("Missing toggle target element");
            }

            if ( !data.toggleclass ) {
                console.warn("Missing toggle class name");
            }

            $(data.target).toggleClass( data.toggleclass );
        });

        setTimeout(() => {
            this.skeletons.each((index, element) => {
                $(element).fadeOut(800);
            });
        }, 800);

        this.button.links.on('click', function (element) {
            if ($(this).is('[disabled]')) {
                element.preventDefault();
            }
        });
    },

    start() {
        setTimeout(() => {
            let activePage = this.navigation.find('li.a');

            $(activePage).removeClass("a").addClass("active");
        }, 500);
    },

    logout() {
        $.ajax({
            url: App.ajaxUrl.switch,
            type: 'post',
            data: {
                library: "account",
                event: "logout",
            },
            success: function (response) {

                let result = JSON.parse(response);

                App.redirect({delay: 1000, url: result.ref});
            },
        });
    },

    showModal(element) {
        $(element).show(0).addClass("visible");
    },

    hideModal(element) {
        $(element).removeClass("visible");
    },

    setModalHeader(element, header) {
        $(element).find("header").text(header);
    },

    setModalSubmitData(element, data) {
        $(element).find(".confirm").data(data);
    }
}
export default Layout;